<template>
  <!-- 客户主页 -->
  <div class="client-page">
    <a href="/dao" style="color: #000000">进入新版>>></a>
    <!-- （1）统计 -->
    <ClientStatistics @totalCountClick="totalCountClick" />
    <!-- （2）图表 -->
    <div>
      <ClientCharts title="客户资产" :showDateSection="false" :tabNames="ClientProperty" />
      <ClientCharts title="业绩表现" :showDateSection="true" :tabNames="salesPerformance"/>
    </div>
  </div>
</template>

<script>
import ClientCharts from "@/component/Client/ClientPage/Charts/ClientCharts";
import ClientStatistics from "@/component/Client/ClientPage/Statistics/ClientStatistics";
export default {
  name: "ClientPage",
  components:{
    ClientCharts,
    ClientStatistics
  },
  data(){
    return {
      ClientProperty:[
        {
          id:0,
          label:'在手订单',
          name:'unfinished_quotation'
        },
        {
          id:1,
          label:'变现存量',
          name:'unfinished_inventory'
        },
        {
          id:2,
          label:'应收款项',
          name:'invoice_not_collection'
        }
      ],
      salesPerformance :[
        {
          id:0,
          label:'净订单',
          name:'estimated_net_quotation'
        },
        {
          id:1,
          label:'开票',
          name:'invoice'
        },
        {
          id:2,
          label:'收款',
          name:'collection'
        }
      ],
    }
  },
  methods: {
    totalCountClick() {
      this.$emit('leftItemselectChange', 'ClientContent')
    }
  }
}
</script>

<style scoped>

</style>